export default __webpack_public_path__ + "static/media/call-center1.8b5746f9.jpg";